import { styled } from "@tamagui/web";
import { SizableText } from "./SizableText.mjs";
const Paragraph = styled(SizableText, {
  name: "Paragraph",
  tag: "p",
  userSelect: "auto",
  color: "$color",
  size: "$true",
  whiteSpace: "normal"
});
export { Paragraph };
//# sourceMappingURL=Paragraph.mjs.map
